/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_ReplaceInputs */



/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Decks_ReplaceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_replace = /** @type {((inputs?: Decks_ReplaceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_ReplaceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Substituir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci")
	return /** @type {LocalizedString} */ ("Replace")
});